const emailRule = [
  v => {
    return !!v || "E-Mail is required";
  },
  v =>
    // /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,128})+$/.test(v) 
    /^[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+(\.[A-Za-z0-9.!#$%&'*+/=?^_`{|}~-]+)*@([A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\.)+[A-Za-z]{2,}$/.test(v)
    ||
    "E-Mail must be valid"
];


const requiredRule = [v => !!v || "required"];

const passwordRule = [
  v => {
    return !!v || "Password is required";
  },
  v =>
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\$%\^&\*])(?=.{10,})/.test(v) ||
    "Min. 10 characters with at least one capital letter, a number and a special character."
];

export { passwordRule, emailRule, requiredRule };
